import { AbstractFilter } from './AbstractFilter'
import { type FilterQuery } from './IQueryableFilter'
import { SortDir } from './SortDir'
import type { FilterPagination } from './FilterPagination'

/** A filter for a paginated, sortable datatable. */
export abstract class BaseFilter extends AbstractFilter {
  protected constructor(public pagination: FilterPagination) {
    super()
  }

  resetPage(): void {
    this.pagination.page = 1
  }

  getSortOrder(): SortDir {
    return this.pagination.sortDir
  }

  static getDefaultPagination = (
    sortBy: null | string = null,
    sortDir: SortDir = SortDir.ASC,
  ): FilterPagination => {
    return {
      page: 1,
      rowsPerPage: 20,
      rowsNumber: 0,
      sortBy: sortBy,
      sortDir: sortDir,
    }
  }

  toBlank(): this {
    const blank = super.toBlank()

    blank.pagination.sortBy = null

    return blank
  }

  toQueryParams(): Record<string, string | string[]> {
    const params = super.toQueryParams()

    params.page = String(this.pagination.page)

    if (this.pagination.sortBy !== null) {
      params.sortBy = this.pagination.sortBy
    }

    params.sortDir = this.pagination.sortDir

    return params
  }

  queryParamKeys(): string[] {
    return [...super.queryParamKeys(), 'page', 'sortBy', 'sortDir']
  }

  applyQueryParams(query: FilterQuery): void {
    super.applyQueryParams(query)

    const page = Number(this.readParam(query.page) ?? NaN)

    if (Number.isInteger(page) && page >= 1) {
      this.pagination.page = page
    }

    const sortBy = this.readParam(query.sortBy)

    if (sortBy !== null) {
      this.pagination.sortBy = sortBy
    }

    const sortDir = this.readParam(query.sortDir)

    if (sortDir === SortDir.ASC || sortDir === SortDir.DESC) {
      this.pagination.sortDir = sortDir
    }
  }
}
